import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'
//import { productUpdateStockTableReady} from '../redux/privileges'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/privilegesTable.css'

class CollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }
    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.role_privileges}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="role_privileges_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal'}}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="role_name"
                        className="table-header"
                        width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Role Name
                    </TableHeaderColumn>                    
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        privileges: state.privileges
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Privileges/Components/CollapsibleRow.js